<app-logo></app-logo>

<div class="h1 page-header mt-160">{{'IOFFER.VERIFICATION.TITLE' | translate }}</div>

<div class="page-header-info">{{'IOFFER.VERIFICATION.SUBTITLE' | translate }}</div>
<div class="page-header-info">{{'IOFFER.VERIFICATION.SUBTITLE2' | translate }}</div>

<div class="mt-40">
    <div class="d-inline-block input--block-mobile">
        <input class="input input--block-mobile"
               style="min-width:250px;"
               type="text"
               [lsnNumPad]="{maxlength: 11, allowLeadingZeros: true}"
               placeholder="{{'LABEL.PESEL' | translate}}"
               [(ngModel)]="pesel"
               maxlength="50">
        <div class="input-warning" *ngIf="wrongPesel$ | async">
            {{ 'IOFFER.VERIFICATION.ERROR.WRONG_PESEL' | translate }}
        </div>
    </div>

    <button class="btn btn--primary btn--block-mobile text-top btn--m-l"
            (click)="confirm()">{{'BUTTON.GO_TO_OFFER' | translate}}</button>
</div>
